import React from 'react';
import type { Control } from 'react-hook-form';
import { DevTool } from '@hookform/devtools';
import { t } from '@lingui/macro';

import { Flex, Text } from '../../core';

import FormAlert, { Props as FormAlertProps } from './FormAlert';

export interface Props extends FormAlertProps {
  children: React.ReactNode;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- allow for flexibility in `control` type
  control?: Control<any>;
  hideRequiredFieldWarning?: boolean;
}

const Form = ({
  children,
  errorMessage,
  onSubmit,
  successMessage,
  control,
  hideRequiredFieldWarning = false,
}: Props): JSX.Element => {
  return (
    <Flex flexDirection="column">
      <FormAlert errorMessage={errorMessage} successMessage={successMessage} />
      {!hideRequiredFieldWarning ? (
        <Text size="100" mb="2x">
          {t`* indicates a required field`}
        </Text>
      ) : undefined}
      <Flex onSubmit={onSubmit} as="form" flexDirection="column" flex="1">
        {children}
      </Flex>
      {control ? <DevTool control={control} /> : null}
    </Flex>
  );
};

export default Form;
